import React from 'react'
import ListMexPage from './ListMexPage'
import '../styles/index.scss'

function ListMexPageContainer() {
    return (
        <div className='ListMexPageContainer'>
            <ListMexPage/>
        </div>
    )
}

export default ListMexPageContainer